import { useCallback } from 'react';
import { ServiceMetricsListItem, ServiceMetricsData } from './types';
import { ROW_TYPES } from './tableConfig';

export const useServiceMetricsListItemBuilder = () => {
  const builder = useCallback(
    ({ data, expandedIds }: { data: ServiceMetricsData[]; expandedIds: Set<number> }) => {
      const header: ServiceMetricsListItem = {
        id: ROW_TYPES.HEADER,
        rowType: ROW_TYPES.HEADER,
        isStickyHeader: true,
        targetServiceId: 0,
        mosaicTeamId: 0,
        integrationHealth: {},
        dataTypeMetrics: {},
      };

      const dataRows: ServiceMetricsListItem[] = data.map((item) => ({
        id: `${item.targetServiceId}`,
        rowType: ROW_TYPES.DATA,
        ...item,
        listItems: [
          {
            id: `${item.targetServiceId}-details`,
            rowType: ROW_TYPES.DETAILS,
            ...item,
            collapseProps: {
              shouldWrapWithCollapse: true,
              isCollapse: expandedIds.has(item.targetServiceId),
            },
            isFullWidthRow: true,
          },
        ],
      }));

      return [header, ...dataRows];
    },
    [],
  );

  return builder;
};

export default useServiceMetricsListItemBuilder;
